
import { defineComponent } from 'vue'
import { LoggedOutSidebar, MobileNav } from '@/components/Layout'
import { Sidebar } from '@/components/Layout/Sidebar'
import AuthMixin from '@/mixins/authMixin'
import PortalMixin from '@/mixins/portalMixin'

export default defineComponent({
  name: 'SidebarOnlyLayout',
  components: {
    Sidebar,
    LoggedOutSidebar,
    MobileNav
  },
  head: {
    bodyAttrs: {
      class: 'antialiased stroke-2 hide-scroll'
    }
  },
  mixins: [AuthMixin, PortalMixin],
  watch: {
    '$route.path': {
      handler() {
        this.resetScroll()
      }
    }
  },
  methods: {
    resetScroll() {
      const divThatScrolls = this.$refs['scrolling-div'] as HTMLElement
      if (divThatScrolls) divThatScrolls.scrollTop = 0
    }
  }
})
